export default __webpack_public_path__ + "static/media/city.caf15900.jpg";